/**
 * interact.js 1.10.26
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/main/LICENSE
 */

import resize from './plugin.js';
import interact from "../../interact/index.js";
import "../../utils/domUtils.js";
import "../../utils/extend.js";
import "../../utils/is.js";

/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
interact.use(resize);
//# sourceMappingURL=index.js.map
